import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';

export const RenderEmailQuestion = ({
  question,
  setQuestions,
  allQuestions,
  setQuestionResults,
  questionResults,
  questionIndex,
  validateEmail,
  editable,
  resultsObj,
  checkForValidEmail,
  formValidation,
  setFormValidation
}) => {

  useEffect(() => {
    if (editable) {
      const manageQuestion = resultsObj.questionResults.filter((emailQ) => emailQ.id === question.id)[0];
      setValue(manageQuestion.answer);
      setQuestionResults([...resultsObj.questionResults]);
    }
  }, [])

  const [value, setValue] = useState('');

  const handleAnswer = (currentValue, index) => {
    // once added, push selectedAnswer to a form array within the parent component. Then on save in the parent, it will be pushed to the API.
    if (formValidation.emailError) {
      setFormValidation({ ...formValidation, emailError: false })
    }

    const questionResultsTemp =
      questionResults.length > 0 ? [...questionResults] : [];
    if (questionResultsTemp.length > 0) {
      // const resultsIndex = questionResultsTemp.indexOf((qu) => {return qu.id === question.id});
      const filterQuestionResults = questionResultsTemp.filter(
        (qu) => qu.id === question.id
      );
      if (filterQuestionResults.length > 0) {
        filterQuestionResults[0].answer = currentValue;
        questionResultsTemp.forEach((item) => {
          if (item.id === filterQuestionResults[0].id) {
            item = { ...filterQuestionResults[0] };
            item.type = question.type;
            item.question = question.value;
          }
        });
      } else {
        const selectedAnswerBase = { questionNumber: 0, answer: '' };
        selectedAnswerBase.id = question.id;
        selectedAnswerBase.type = question.type;
        selectedAnswerBase.questionNumber = questionIndex;
        selectedAnswerBase.question = question.value;
        selectedAnswerBase.answer = currentValue;
        selectedAnswerBase.answers = [];
        questionResultsTemp.push(selectedAnswerBase);
      }
    } else {
      const selectedAnswerBase = { questionNumber: 0, answer: '' };
      selectedAnswerBase.id = question.id;
      selectedAnswerBase.type = question.type;
      selectedAnswerBase.questionNumber = questionIndex;
      selectedAnswerBase.question = question.value;
      selectedAnswerBase.answer = currentValue;
      selectedAnswerBase.answers = [];
      questionResultsTemp.push(selectedAnswerBase);
    }
    setQuestionResults([...questionResultsTemp]); // currently assigns data to the question results in parent.
  };

  useEffect(() => {
    handleAnswer(value);
  }, [value]);

  const { emailError } = formValidation

  return (
    <TextField
      type='email'
      value={value}
      error={emailError}
      helperText={emailError ? 'Please insert a valid email address' : ''}
      onChange={async (e) => setValue(e.target.value)}
    />
  );
};
